import { DURATIONS, FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { FiltersWrapper } from './FiltersWrapper';
import { Select } from 'foundations-components/components/Select';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => DURATIONS.map(duration => ({
  text: I18n.text(`academyComponents.topFilters.duration.${duration}`),
  value: duration
}));
export const DurationFilter = ({
  appearsIn
}) => {
  const [duration, setDuration] = useSearchParam(FILTER_TYPES.DURATION);
  const handleDurationChange = selectedDuration => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: selectedDuration.length ? 'filter-selected' : 'filter-deselected',
      value: selectedDuration,
      isDropdown: true,
      key: 'duration-filter',
      appearsIn
    });
    setDuration(selectedDuration);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": I18n.text('academyComponents.topFilters.duration.filterTitle'),
      clearable: true,
      menuInlineSize: 200,
      multi: true,
      onSelectedOptionChange: evt => {
        handleDurationChange(evt.selectedValues);
      },
      options: getOptions(),
      selectedItemsPlaceholder: I18n.text('academyComponents.topFilters.duration.filterTitle'),
      selectedValues: duration
    })
  });
};